import {
  LIST_TILES_API,
  TILES_API,
  TILES_API_WITH_AVAILABILITIES,
} from '@fire/constants';

export const TILES_ENDPOINT = `${TILES_API}`;
export const TILES_WITH_AVAILABILITIES = `${TILES_API_WITH_AVAILABILITIES}`;
export const TILES_LIST_WITH_FALLBACK = `${LIST_TILES_API}?fallback_nonbookable_amount=11&flexible_dates=true`;
